module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_id_card_jp.2a46f154be8ecb32f43ae20273ea5859.png";